import React, { FC } from 'react';
import Form from 'components/Form';

import { KukidentPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Kukident: FC<KukidentPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Kukident;
